export default {
  init() {
    $('.wmtm-newsletter-form').on('submit', (e) => {
      var email = $(e.currentTarget).find('input[type="email"]').val();
      $('#newsletter-popup input[type="email"]').val(email);
      $('#newsletter-popup').fadeIn(200);
      e.preventDefault();
    });

    $('.wmtm-newsletter-close').on('click', () => {
      $('#newsletter-popup').fadeOut(200);
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/htheme/pagebuilder/components/newsletter.js